/** Plan de diagnóstico MSP — tabla dual diagnóstico / CIE-10 / PRE / DEF */

export const MSP_DIAG_ROW_BLANK = { diagnostico: '', cie10: '', tipo: 'presuntivo' };

/** Filas mínimas en el formato MSP (2 + 2 columnas). */
export const MSP_DIAG_MIN_FILAS = 4;

export function diagnosticoFilaTieneDatos(row) {
  return !!(String(row?.diagnostico || '').trim() || String(row?.cie10 || '').trim());
}

export function diagnosticosConDatos(rows) {
  return sanitizeTablaDiagnosticosMSP(rows).filter(diagnosticoFilaTieneDatos);
}

function mapDiagnosticoRow(r, { trim = false } = {}) {
  const norm = (v) => {
    const s = String(v ?? '');
    return trim ? s.trim() : s;
  };
  return {
    diagnostico: norm(r?.diagnostico),
    cie10: norm(r?.cie10),
    tipo: r?.tipo === 'definitivo' ? 'definitivo' : 'presuntivo',
  };
}

/** Estructura mínima sin recortar espacios — usar mientras el usuario escribe. */
export function ensureTablaDiagnosticosMSPStructure(rows) {
  const arr = Array.isArray(rows) ? rows : [];
  const out = arr.map((r) => mapDiagnosticoRow(r, { trim: false }));
  const base = out.length ? out : [{ ...MSP_DIAG_ROW_BLANK }];
  while (base.length < MSP_DIAG_MIN_FILAS) {
    base.push({ ...MSP_DIAG_ROW_BLANK });
  }
  return base;
}

/** Normaliza y recorta espacios — solo al cargar o guardar. */
export function sanitizeTablaDiagnosticosMSP(rows) {
  const arr = Array.isArray(rows) ? rows : [];
  const out = arr.map((r) => mapDiagnosticoRow(r, { trim: true }));
  const base = out.length ? out : [{ ...MSP_DIAG_ROW_BLANK }];
  while (base.length < MSP_DIAG_MIN_FILAS) {
    base.push({ ...MSP_DIAG_ROW_BLANK });
  }
  return base;
}

export function migrateLegacyDiagnosticosMSPTable(form) {
  const raw = form.tablaDiagnosticosMSP;
  if (Array.isArray(raw) && raw.some((r) => (String(r?.diagnostico || '').trim() || String(r?.cie10 || '').trim()))) {
    return raw;
  }
  const rows = [];
  const pairs = [
    [form.diagnosticoPresuntivo1, form.diagnosticoPresuntivoCIE10_1, 'presuntivo'],
    [form.diagnosticoDefinitivo1, form.diagnosticoDefinitivoCIE10_1, 'definitivo'],
    [form.diagnosticoPresuntivo2, form.diagnosticoPresuntivoCIE10_2, 'presuntivo'],
    [form.diagnosticoDefinitivo2, form.diagnosticoDefinitivoCIE10_2, 'definitivo'],
    [form.diagnosticoPresuntivo3, form.diagnosticoPresuntivoCIE10_3, 'presuntivo'],
    [form.diagnosticoDefinitivo3, form.diagnosticoDefinitivoCIE10_3, 'definitivo'],
    [form.diagnosticoPresuntivo4, form.diagnosticoPresuntivoCIE10_4, 'presuntivo'],
    [form.diagnosticoDefinitivo4, form.diagnosticoDefinitivoCIE10_4, 'definitivo'],
  ];
  for (const [dx, cie, tipo] of pairs) {
    const d = String(dx || '').trim();
    const c = String(cie || '').trim();
    if (d || c) rows.push({ diagnostico: d, cie10: c, tipo });
  }
  return rows.length ? rows : [{ ...MSP_DIAG_ROW_BLANK }];
}

/** Divide filas en bloque izquierdo y derecho (1–2 | 3–4 …). */
export function splitDiagnosticosDual(rows) {
  const list = ensureTablaDiagnosticosMSPStructure(rows);
  const mid = Math.ceil(list.length / 2);
  return {
    left: list.slice(0, mid).map((row, i) => ({ row, index: i })),
    right: list.slice(mid).map((row, i) => ({ row, index: mid + i })),
  };
}
